import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncateText',
})
export class TruncateTextPipe implements PipeTransform {
    transform(text: string, maxLength: number): string {
        return text.slice(0, maxLength) + '...';
    }
}